export const selectAppInfo = (state: any) => state.appInfo;